import React, { useState } from 'react'
import { ProfileAvatar } from 'src/component/nav/profile-settings/profile-avatar'
import { PhotoUploadDialog } from 'src/component/profile/personal-info/photo-upload-dialog'
import { LinkButton } from 'src/component/ui/button'

export const ProfilePhoto = (): React.ReactElement => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <h6 className="font-evogria text-sm md:text-base text-ivory uppercase mb-4">Photo</h6>
      <div className="relative inline-block group">
        <ProfileAvatar size="large" />
        <LinkButton
          size="sm"
          onClick={() => setIsDialogOpen(true)}
          className="text-ivory uppercase absolute inset-0 w-full h-full flex items-center justify-center bg-black/50 hover:bg-black/70 rounded-[4px] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        >
          Change
        </LinkButton>
      </div>
      <PhotoUploadDialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
    </>
  )
}
